<template>
    <CModal @mtdclosemodal="mtdClose" :show="boo_modal" :btn_cancel="true" :centered="true" :title="title" :size="'md'">
        <CRow>
            <CCol sm="12">
                <div v-for="(items, index) in data_roles" :key="index"
                    class="col-xl-3 col-lg-12 col-md-12 col-sm-12 col-xs-12 mb-3">
                    <div class="checkbox-grid">
                        <label class="checkbox-label">
                            <input type="checkbox" :value="items.value" class="form-check-input"
                                v-model="data_detail.checkbox" :disabled="items.value == 1" />
                            <span class="ms-2">{{ items.text }}</span>
                        </label>
                    </div>
                </div>
            </CCol>
        </CRow>
        <template #footer>
            <button @click="mtdClose" class="btn btn-danger btn-sm">
                <i class="fa fa-times"></i>&nbsp;Cerrar
            </button>
            <button @click="updateRoles" class="btn btn-success btn-sm">
                Actualizar
            </button>
        </template>
    </CModal>
</template>

<script>
import CModal from "../../../shared/modals/cModalFormCom.vue";
import { mapActions } from "vuex";

export default {
    components: { CModal },
    data() {
        return {
            swall: null,
            data_roles: [],
            data_detail: {
                checkbox: [],
            },
        }
    },
    created() {
        this.byRol();
    },
    watch: {
        // item(newItem) {
        //     if (newItem && newItem.companyRole) {
        //         this.rolesCheck();
        //     }
        // },
        boo_modal(newVal) {
            if (newVal) {
                this.data_detail.checkbox = [];
                if (this.item && this.item.companyRole) {
                    this.rolesCheck();
                }
            }
        }
    },
    props: {
        title: String,
        boo_modal: Boolean,
        id_company: Number,
        item: Object
    },
    methods: {
        ...mapActions(["get", "post"]),
        mtdClose() {
            this.$emit("mtd_closeAddRoles");
        },
        byRol: function () {
            this.get({
                url: this.$store.getters.get__url + "/rol",
                token: this.$store.getters.get__token,
            }).then((response) => {
                response.data.data.forEach((element) => {
                    this.data_roles.push({
                        text: element.Nombre,
                        value: element.Id,
                    });
                });
            })
        },
        rolesCheck() {
            if (this.item.companyRole && this.item.companyRole.length > 0) {
                this.item.companyRole.forEach(role => {
                    const roleInData = this.data_roles.find(r => r.value === role.role_id);
                    if (roleInData) {
                        this.data_detail.checkbox.push(roleInData.value);
                    }
                });
            }
        },
        updateRoles() {
            let selectedRoles = this.data_detail.checkbox;
            this.post({
                url: this.$store.getters.get__url + "/companyRole/addroles",
                token: this.$store.getters.get__token,
                params: {
                    companyId: this.id_company,
                    roles: selectedRoles
                }
            }).then((response) => {
                if (response.statusCode == 200) {
                    Swal.fire({
                        title: "Roles registrados correctamente",
                        icon: "success"
                    });
                    this.$emit("mtd_closeAddRoles");
                } else {
                    Swal.fire({
                        title: "Error al registrar los roles",
                        icon: "error"
                    })
                }
            })
        }


    }
}
</script>